module.exports = __webpack_public_path__ + "static/img/F_b.d268646.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/tab/F_b.png
// module id = Q/Wo
// module chunks = 69